module.exports = "/images/intercard.white.svg?ae1578c5a8593ef13217fff3c70c9072";